(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blingstyle-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('blingstyle-product')) {
  customElements.define('blingstyle-product', class extends HTMLElement {
    connectedCallback() {
      if(this.initialized)return; this.initialized=true;
      this.abort=new AbortController();const signal=this.abort.signal;
      const q=s=>this.querySelector(s);
      this.select=q('.bs-native');if(!this.select)return;
      this.labels=JSON.parse(q('[data-labels]').textContent);
      this.slides=[...this.querySelectorAll('.bs-slide')];this.stage=q('.bs-stage');this.thumbs=q('.bs-thumbs');this.index=0;
      const variants=q('.bs-variants');const colours={red:'#ca2535',pink:'#f29bb8',black:'#202020',beige:'#dccbaa'};
      [...this.select.options].forEach(option=>{
        const b=document.createElement('button');b.type='button';b.dataset.id=option.value;
        const dot=document.createElement('span');dot.className='bs-dot';dot.style.background=colours[option.dataset.colour]||'#ded8d1';dot.setAttribute('aria-hidden','true');
        b.append(dot,document.createTextNode(option.dataset.title+(option.dataset.available==='true'?'':' — '+this.labels.sold)));
        b.addEventListener('click',()=>{this.select.value=option.value;this.select.dispatchEvent(new Event('change',{bubbles:true}));},{signal});variants.append(b);
      });
      variants.hidden=false;this.select.hidden=true;
      this.select.addEventListener('change',()=>this.update(true),{signal});
      q('[data-prev]').addEventListener('click',()=>this.go(this.index-1),{signal});q('[data-next]').addEventListener('click',()=>this.go(this.index+1),{signal});
      this.stage.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{let best=0,d=Infinity;const left=this.stage.getBoundingClientRect().left;this.visible.forEach((s,i)=>{const distance=Math.abs(s.getBoundingClientRect().left-left);if(distance<d){d=distance;best=i;}});this.index=best;this.mark();});},{signal});
      const dialog=q('dialog');
      this.slides.forEach(s=>s.addEventListener('click',e=>{if(!dialog.showModal)return;e.preventDefault();const img=dialog.querySelector('img');img.src=s.href;img.alt=s.querySelector('img').alt;dialog.showModal();},{signal}));
      q('[data-close]').addEventListener('click',()=>dialog.close(),{signal});dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();},{signal});
      q('.bs-gallery-controls').hidden=false;this.thumbs.hidden=false;
      const bar=q('.bs-mobile-bar');this.observer=new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting;},{threshold:0});this.observer.observe(q('.bs-buy-row'));
      this.update(false);
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);this.initialized=false;this.querySelector('.bs-variants')?.replaceChildren();}
    update(changeURL){
      const o=this.select.selectedOptions[0],d=o.dataset;
      this.querySelector('[data-selection]').textContent=d.title;
      this.querySelector('.bs-price [data-price]').textContent=d.price;this.querySelector('[data-sticky-price]').textContent=d.price;
      const compare=this.querySelector('.bs-price [data-compare]');compare.textContent=d.compare;compare.hidden=!d.compare;
      this.querySelector('[data-stock]').textContent=d.available==='true'?this.labels.stock:this.labels.sold;
      this.querySelectorAll('[data-add]').forEach(b=>{b.disabled=d.available!=='true';b.textContent=d.available==='true'?this.labels.add:this.labels.sold;});
      this.querySelectorAll('.bs-variants button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.id===o.value)));
      const qty=this.querySelector('[name=quantity]');qty.min=d.min||1;qty.step=d.step||1;if(d.max)qty.max=d.max;else qty.removeAttribute('max');qty.value=qty.min;
      const custom=this.slides.filter(s=>s.hasAttribute('data-custom')&&s.dataset.colour===d.colour);
      const colourNames=[...this.select.options].map(x=>x.dataset.colour);
      let originals=this.slides.filter(s=>s.hasAttribute('data-original')).filter(s=>{
        const a=(s.dataset.alt||'').trim().toLowerCase();const tag=a.split('|')[0].trim();
        return !colourNames.includes(tag)||tag===d.colour;
      });
      const featured=originals.find(s=>s.dataset.mediaId===d.media);if(featured) originals=[featured,...originals.filter(s=>s!==featured)];
      this.visible=custom.length?custom:originals;if(!this.visible.length)this.visible=this.slides.filter(s=>s.hasAttribute('data-original'));
      this.slides.forEach(s=>s.hidden=true);this.visible.forEach(s=>{s.hidden=false;this.stage.append(s);});
      this.thumbs.replaceChildren();this.visible.forEach((s,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',this.labels.view+' '+(i+1));const img=s.querySelector('img').cloneNode();img.removeAttribute('fetchpriority');img.loading='lazy';img.alt='';b.append(img);b.addEventListener('click',()=>this.go(i),{signal:this.abort.signal});this.thumbs.append(b);});
      this.index=0;this.stage.scrollLeft=0;this.mark();
      if(changeURL){const url=new URL(location.href);url.searchParams.set('variant',o.value);history.replaceState({},'',url);}
    }
    go(i){if(!this.visible.length)return;this.index=(i+this.visible.length)%this.visible.length;const el=this.visible[this.index];this.stage.scrollTo({left:this.stage.scrollLeft+el.getBoundingClientRect().left-this.stage.getBoundingClientRect().left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.mark();}
    mark(){this.querySelector('[data-count]').textContent=this.visible.length?(this.index+1)+' / '+this.visible.length:'0 / 0';[...this.thumbs.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
